// Keeps the app frame sized to the VISIBLE viewport when the soft keyboard is up.
//
// Chromium resizes the layout viewport for the keyboard (the viewport meta asks
// for that with interactive-widget=resizes-content), so 100dvh is already right
// there. Safari — including the installed iOS app — instead lays the keyboard
// OVER the page: 100dvh keeps the full height and the compose bar ends up
// underneath. The visual viewport is the one measure that shrinks in both
// worlds, so we mirror it into --app-height and let the frame's CSS pick it up.

export function attachViewport(): void {
  const viewport = window.visualViewport;
  if (viewport === null || viewport === undefined) {
    return;
  }

  const apply = (): void => {
    const height = Math.round(viewport.height);
    if (height <= 0) {
      return;
    }
    if (height >= window.innerHeight) {
      // Nothing overlays: let the 100dvh declaration rule so the URL-bar
      // animation stays smooth instead of stepping through JS updates.
      document.documentElement.style.removeProperty('--app-height');
    } else {
      document.documentElement.style.setProperty('--app-height', `${height}px`);
    }
  };

  viewport.addEventListener('resize', apply);
  viewport.addEventListener('scroll', apply);
  apply();
}
